import { Grid2 } from "@mui/material";
import style from "./NoGraphData.module.scss";
import { ReactComponent as NoGraph } from "../../../../../Admin/AdminAssets/svg/NoGraphData.svg";
const NoGraphData = (props) => {
  return (
    <Grid2 className={style.NoGraphData}>
      <NoGraph />
      <Grid2 className={style.noData}>No data found.</Grid2>
      <Grid2 className={style.nodatasub}>
        The data will be accessible in the next 24 hours.
      </Grid2>
    </Grid2>
  );
};

export default NoGraphData;
